import * as React from 'react';
import S from './FeatureList.styles';
const FeatureList = (props) => {
    return (React.createElement(S.Container, { "data-active": props.active }, props.items.map((item) => (React.createElement(S.Item, { key: item }, item)))));
};
export default FeatureList;
